import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import type { JSX } from 'react';
/**
 * Props for `Space`.
 */
export type SpaceProps = SliceComponentProps<Content.SpaceSlice>;

/**
 * Component for "Space" Slices.
 */
const Space = ({ slice }: SpaceProps): JSX.Element => {
  const { backgroundColor, height } = slice.primary;

  const sectionStyle: React.CSSProperties = {
    height: height ? `${height}px` : undefined,
    backgroundColor: backgroundColor || undefined
  };

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <div style={sectionStyle} />
    </section>
  );
};

export default Space;
